<template>
    <div class="honor">
      <div class="hotCarsTitle">
        <div class="hctMain clearfix">
          <div class="hctMainImg"><img :src="hctIcon" alt=""></div>
          <div class="hctMainTitle">荣誉资质</div>
        </div>
      </div>
      <div class="honnerImg">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(image, index) in publicData.RYZZ" :key="index">
              <img v-lazy="image" />
            </van-swipe-item>
          </van-swipe>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'Honor',
        props:['publicData'],
        data () {
            return {
              hctIcon:require("../../assets/icon_hotCar.png"),
              images: [require("../../assets/icon_carType01.jpg"),require("../../assets/icon_carType02.jpg"),require("../../assets/icon_carType03.jpg"),require("../../assets/icon_carType04.jpg")]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .hotCarsTitle{width: 100%;height: 60px;background: #f6f6f6}
    .hctMain{width: 300px;background: #2c3e50;background: linear-gradient(-45deg, transparent 45px, #2c3e50 0) bottom right;height: 60px; background-repeat: no-repeat;display: flex}
    .hctMainImg{display: flex;padding-left: 20px;box-sizing: border-box;align-items: center;height: 60px;}
    .hctMainImg img{width: 32px;height: 32px;vertical-align: middle}
    .hctMainTitle{display: flex;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);align-items: center;margin-left: 20px;}

    .honnerImg{width: 400px;margin: 40px auto;height: 390px;}
</style>

<style>
  /*.van-swipe{width: 100%;height: 100%}*/
  /*.van-swipe-item img{width: 100%;height: 100%}*/
  /*.van-swipe__indicators{bottom: -10%}*/
  .van-swipe__indicator{width: 12px;height: 12px;background: #4d667e;opacity: 1}
  .van-swipe__indicator--active{background: #1dd2af}
</style>



// WEBPACK FOOTER //
// src/components/Honor/Honor.vue